import { TRANSFER_TRANSPORT_TYPES, isTransferTransports } from '@bandido/shared/types';
import type { TransferTransportType, TransferTransports } from '@bandido/shared/types';
import type { DeclaredPassengerFields } from './passengerFields';

export function supportedTransportTypes(value: unknown): TransferTransportType[] {
  return Array.isArray(value) ? TRANSFER_TRANSPORT_TYPES.filter((type) => value.includes(type)) : [];
}

/** null bloquea el hold; undefined significa que no hay datos para enviar. */
export function transferTransportsForHold(
  enabled: boolean,
  draft: TransferTransports,
  supported: readonly TransferTransportType[],
  roundTrip: boolean,
): TransferTransports | null | undefined {
  if (!enabled) return undefined;
  if (!supported.length || (!roundTrip && draft.return)) return null;
  if (!Object.keys(draft).length) return undefined;
  if (!isTransferTransports(draft)) return null;
  const result: TransferTransports = {};
  for (const direction of ['outbound', 'return'] as const) {
    const ends = draft[direction];
    if (!ends) continue;
    for (const end of ['origin', 'destination'] as const) {
      const value = ends[end];
      if (!value) continue;
      if (!supported.includes(value.type)) return null;
      const resultEnds = (result[direction] ??= {});
      resultEnds[end] = {
        type: value.type,
        number: value.number.trim(),
        ...(value.company?.trim() ? { company: value.company.trim() } : {}),
        ...(value.scheduledLocalTime ? { scheduledLocalTime: value.scheduledLocalTime } : {}),
      };
    }
  }
  return result;
}

export function transportPassengerFields(
  fields: DeclaredPassengerFields,
  enabled: boolean,
): DeclaredPassengerFields {
  if (!enabled) return fields;
  const retain = (entry: DeclaredPassengerFields['all'][number]) =>
    !['flightNumber', 'returnFlightNumber'].includes(entry.field) || entry.level !== 'recommended';
  return { ...fields, all: fields.all.filter(retain), contact: fields.contact.filter(retain) };
}

export function hasRequiredLegacyFlight(fields: DeclaredPassengerFields): boolean {
  return [...fields.all, ...fields.contact].some(
    (entry) => ['flightNumber', 'returnFlightNumber'].includes(entry.field) && entry.level !== 'recommended',
  );
}
